import React from 'react'
import { Container } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import SideBar from 'components/Common/SideBar'
import Navbar from 'components/Common/Navbar'
const MainLayout = ({ children }) => {
  const theme = useTheme()
  return (
    <Container
      maxWidth="xl"
      sx={{
        paddingTop: theme.sizes.header.height,
        paddingLeft: '100px !important',
        paddingRight: '40px !important',
        paddingBottom: '30px',
      }}
    >
      <Navbar />
      <SideBar />
      {children}
    </Container>
  )
}

export default MainLayout
